import React, { useEffect, useState } from 'react';
import { Button, Card, Result, Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../components/Layout/AuthContext';
import { orderApi } from '../../../services/process/order';

type LoadState =
  | { status: 'loading' }
  | { status: 'empty' }
  | { status: 'ready'; orderNo: string };

/**
 * 在审订单过渡页：尝试获取一个在审订单并跳转到审核页
 */
const OrderAuditInProgress: React.FC = () => {
  const navigate = useNavigate();
  const { staff } = useAuth();
  const currentUserId = staff?.id || 0;
  const [state, setState] = useState<LoadState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      setState({ status: 'loading' });
      try {
        if (!currentUserId) {
          setState({ status: 'empty' });
          return;
        }

        const res = await orderApi.list({
          page: 1,
          pageSize: 1,
          scene: 'tab_audit_wait_all',
          filter: {
            audit_status: { operator: 'eq', value: 1 },
            audit_id: { operator: 'eq', value: currentUserId },
          },
        });
        const orderNo = res?.data?.items?.[0]?.order?.orderNo
          ? String(res.data.items[0].order.orderNo)
          : undefined;

        if (cancelled) return;
        if (orderNo) {
          setState({ status: 'ready', orderNo });
          navigate(`/order/audit/${orderNo}`, { replace: true });
          return;
        }
        setState({ status: 'empty' });
      } catch (e) {
        if (cancelled) return;
        message.error('获取在审订单失败');
        setState({ status: 'empty' });
      }
    };

    run();
    return () => { cancelled = true; };
  }, [navigate, currentUserId]);

  if (state.status === 'loading') {
    return (
      <div style={{ padding: 24 }}>
        <Card>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '48px 0' }}>
            <Spin tip="正在获取在审订单..." />
          </div>
        </Card>
      </div>
    );
  }

  if (state.status === 'empty') {
    return (
      <div style={{ padding: 24 }}>
        <Card>
          <Result
            status="info"
            title="当前暂无在审订单"
            extra={[
              <Button key="go-wait" type="primary" onClick={() => navigate('/order/audit/wait')}>
                跳转到待审订单
              </Button>,
            ]}
          />
        </Card>
      </div>
    );
  }

  return null;
};

export default OrderAuditInProgress;
